import { Archive } from 'lucide-react';
import { Button } from './Button';

/**
 * The one "show archived" control.
 *
 * It arrived three times in three shapes: a `SegmentedControl` on /clients
 * (Active · Archived · All), a bare checkbox on /agreements, and a counted
 * toggle button on /team. Same idea, three silhouettes, three positions in the
 * filter bar — and only one of them told you whether there was anything
 * archived to look at, which is the difference between a control and a
 * question mark.
 *
 * This is the counted toggle, because a count is what makes it worth clicking,
 * and it composes with a type filter instead of competing with one for the
 * segmented-strip slot. It renders nothing when there is nothing archived.
 */
export function ArchivedToggle({
  active,
  count,
  onChange,
  /** What is archived, plural: "agreements", "clients", "people". */
  noun,
}: {
  active: boolean;
  count: number;
  onChange: (next: boolean) => void;
  noun: string;
}) {
  if (count === 0 && !active) return null;
  return (
    <Button
      variant={active ? 'primary' : 'outline'}
      size="sm"
      aria-pressed={active}
      title={active ? `Hide archived ${noun}` : `Also show ${count} archived ${noun}`}
      onClick={() => onChange(!active)}
    >
      <Archive className="h-4 w-4" aria-hidden />
      {active ? 'Hide archived' : `Archived (${count})`}
    </Button>
  );
}
